import React from 'react';
import { Eye, Heart, Palmtree } from 'lucide-react';
interface BadgeProps {
  variant: 'rose-sparkle' | 'orange-ampersand' | 'yellow-star' | 'lightrose-eye' | 'blue-palmtree' | 'peach-heart';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  label?: string;
  className?: string;
}
export function Badge({
  variant,
  size = 'md',
  label,
  className = ''
}: BadgeProps) {
  const sizes = {
    sm: 'w-10 h-10',
    md: 'w-14 h-14',
    lg: 'w-20 h-20',
    xl: 'w-24 h-24'
  };
  const iconSizes = {
    sm: 18,
    md: 24,
    lg: 36,
    xl: 44
  };
  // Custom 8-point star SVG for the sparkle
  const StarBurst = ({
    size,
    color
  }: {
    size: number;
    color: string;
  }) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-65">
      <path d="M12 2v20M2 12h20M4.929 4.929l14.142 14.142M4.929 19.071L19.071 4.929" data-id="element-66" />
    </svg>;
  const renderContent = () => {
    let bgColor, ringColor, iconColor, icon;
    switch (variant) {
      case 'rose-sparkle':
        bgColor = 'bg-jany-pink-pale';
        ringColor = 'border-jany-pink';
        iconColor = '#FF6B9D';
        icon = <StarBurst size={iconSizes[size]} color={iconColor} data-id="element-67" />;
        break;
      case 'orange-ampersand':
        bgColor = 'bg-jany-orange-pale';
        ringColor = 'border-jany-orange';
        iconColor = 'text-jany-orange';
        icon = <span className={`font-display leading-none ${iconColor}`} style={{
          fontSize: iconSizes[size] * 1.2
        }} data-id="element-68">
            &
          </span>;
        break;
      case 'yellow-star':
        bgColor = 'bg-jany-cream'; // Using cream as pale yellow
        ringColor = 'border-jany-yellow';
        iconColor = '#FFD34D';
        icon = <StarBurst size={iconSizes[size]} color={iconColor} data-id="element-69" />;
        break;
      case 'lightrose-eye':
        bgColor = 'bg-jany-orange-pale';
        ringColor = 'border-jany-orange';
        iconColor = '#FF8A3D';
        icon = <Eye size={iconSizes[size]} strokeWidth={1.5} color={iconColor} data-id="element-70" />;
        break;
      case 'peach-heart':
        bgColor = 'bg-jany-orange-pale';
        ringColor = 'border-jany-pink';
        iconColor = '#FF6B9D';
        icon = <Heart size={iconSizes[size]} strokeWidth={1.5} color={iconColor} data-id="element-71" />;
        break;
      case 'blue-palmtree':
        bgColor = 'bg-jany-blue-pale';
        ringColor = 'border-jany-blue-saturated';
        iconColor = '#5BAEF0';
        icon = <Palmtree size={iconSizes[size]} strokeWidth={1.5} color={iconColor} data-id="element-72" />;
        break;
      default:
        return null;
    }
    return <div className={`flex flex-col items-center ${className}`} data-id="element-73">
        <div className={`flex items-center justify-center rounded-full border-2 ${bgColor} ${ringColor} ${sizes[size]} shadow-sm`} data-id="element-74">
          {icon}
        </div>
        {label && <span className={`mt-2 text-[0.65rem] font-bold tracking-widest uppercase ${iconColor.startsWith('#') ? `text-[${iconColor}]` : iconColor}`} data-id="element-75">
            {label}
          </span>}
      </div>;
  };
  return renderContent();
}